import React, { useContext} from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import '../../css/admin_dashboard.css';
import { useState } from 'react';
import  Dashboard from '../../../../media/dashboard_white.png';
import  Category from '../../../../media/category.png';
import  Teacher from '../../../../media/teacher.png';
import  Courses from '../../../../media/courses_white.png';
import  Contents from '../../../../media/courses_content.png';
import  Organization from '../../../../media/organization.png';
import  User from '../../../../media/user.png';
import  Settings from '../../../../media/settings.png';
import  Home from '../../../../media/home_white.png';
import  Logout from '../../../../media/logout_white.png';
import { AuthContext } from "../../../../services/authContext";
import logo from '../../../../media/logo.png';

const AdminDashboard = () => {
  const { logout } = useContext(AuthContext);
  const location = useLocation();

  

  return (
    <div className="admin-dashboard">
      <aside className="admin-sidebar">
        <h3 className="admin-title"> <img src={logo} alt="Logo" className="navbar-logo" /> Actafad Admin</h3>
        <ul className="admin-menu">
          <li>
            <NavLink to="/admin" end>
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Dashboard}
                    alt={""}
                    className="img-sidebar"
                  />
                   Dashboard
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/categorie">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Category}
                    alt={""}
                    className="img-sidebar"
                  />
                  Categorie
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/insegnanti">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Teacher}
                    alt={""}
                    className="img-sidebar"
                  />
                  Insegnanti
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/corsi">
              {({ isActive }) => {
                const active =
                  isActive || location.pathname.startsWith("/admin/moduli");

                return (
                  <div className={active ? "active" : ""}>
                    <img
                      src={Courses}
                      alt=""
                      className="img-sidebar"
                    />
                    Corsi
                  </div>
                );
              }}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/enti">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Organization}
                    alt={""}
                    className="img-sidebar"
                  />
                  Enti
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/utenti">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={User}
                    alt={""}
                    className="img-sidebar"
                  />
                  Utenti
                </div>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/impostazioni">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Settings}
                    alt={""}
                    className="img-sidebar"
                  />
                  Impostazioni
                </div>
              )}
            </NavLink>
          </li>
        </ul>
        <ul className="admin-menu">
           <li>
            <NavLink to="/">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""}>
                  <img
                    src={Home}
                    alt={""}
                    className="img-sidebar"
                  />
                  Home
                </div>
              )}
            </NavLink>
          </li>
           <li>
            <NavLink to="/">
              {({ isActive }) => (
                <div className={isActive ? "active" : ""} onClick={logout}>
                  <img
                    src={Logout}
                    alt={""}
                    className="img-sidebar"
                  />
                  Logout
                </div>
              )}
            </NavLink>
          </li>
        </ul>
      </aside>

      <main className="admin-main">
       
        <Outlet />
      </main>
    </div>
  );
};

export default AdminDashboard;
